import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { StoreContext } from "shared/context/store-context";
import { AuthContext } from "shared/context/auth-context";
import { USER_TYPES } from "@routebot/constants";
import { getColumnValue } from "shared/util/datagrid";
import { noRealSchoolBlocker } from "shared/utility/blocker-conditions";

import Layout from "layouts/LayoutMasterDetail";

import ParentItem from "./ParentItem";

const ParentsList = () => {
  const { t } = useTranslation();
  const listName = "main_parents";
  const itemType = "parent";

  const { users, schools, schoolOptions, DeleteUser, InsertUser, UpdateUser } = useContext(StoreContext);

  // Simdilik tum userlar donuyor. Biz de burada filtreleme yapiyoruz

  let pageItems = users.filter((user) => user.usertype === USER_TYPES.SCHOOL_PARENT);

  // const auth = useContext(AuthContext);
  // const authSchools = auth.schools.map((school) => school.id);

  // pageItems = pageItems.filter((user) => {
  //   // user.school bir array, authSchools ile kesişim kontrolü yap
  //   if (!user.school || user.school.length === 0) return false;
  //   return user.school.some((schoolId) => authSchools.includes(schoolId));
  // });
  // // Simdilik tum userlar donuyor. Biz de burada filtreleme yapiyoruz

  let listColumns = [];

  if (schoolOptions?.length > 1) {
    listColumns.push(getColumnValue("school", t("client"), schoolOptions, "school", 300));
  }

  listColumns.push({ field: "name", headerName: t("name"), width: 300 });
  listColumns.push({ field: "phonenumber", headerName: t("phone"), width: 200 });
  listColumns.push({ field: "address", headerName: t("address"), width: 450 });
  listColumns.push({ field: "email", headerName: t("email"), width: 150, hide: true });
  listColumns.push({ field: "identity", headerName: t("identity"), width: 150, hide: true });

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      SelectedItemComponent={ParentItem}
      NewItemComponent={ParentItem}
      DeleteItem={DeleteUser}
      InsertItem={InsertUser}
      UpdateItem={UpdateUser}
      hideCreateNewItemWhenSelected={true}
      blockerConditions={[noRealSchoolBlocker(schools)]}
    />
  );
};

export default ParentsList;
